import React from "react";

const IconBell = () => {
  return (
    <svg width="22" height="22" viewBox="0 0 19 19.5">
      <g dataname="Group 909" transform="translate(-1608.5 -91.5)">
        <g transform="translate(1606 89.5)">
          <path
            dataname="Path 3592"
            d="M6,8.5V10a3.2,3.2,0,0,1-.8,2.1L4,13.7a5.1,5.1,0,0,0-1,3v.8H21v-.8a5.1,5.1,0,0,0-1-3l-1.2-1.6A3.2,3.2,0,0,1,18,10V8.5a6,6,0,0,0-6-6h0a6,6,0,0,0-6,6Z"
            fill="none"
            stroke="#000"
            strokeWidth="1"
          />
          <path
            dataname="Path 3593"
            d="M15,18a3,3,0,0,1-6,0"
            fill="none"
            stroke="#000"
            strokeLinejoin="bevel"
            strokeWidth="1"
          />
        </g>
      </g>
    </svg>
  );
};

export default IconBell;
